import { call, delay, put } from "redux-saga/effects";
import {
    IAuthDataSourceRecord,
    IAuthParams,
    IAuthSessionData,
} from "./AuthModel";
import {
    hasUserOnSubscriptionPreferencesAction,
    showErrorOnSubscriptionPreferencesAction,
} from "../../subscriptionPreferences/subscriptionPreferencesActions";
import { fetchSaga, TApiResult } from "../_services/apiCalls";
import { subscriptionPreferencesAT } from "../../subscriptionPreferences/SubscriptionPreferencesModel";
import { loadDynamicContent } from "../loadDynamicContent/loadDynamicContentSaga";

const authKey = "userManagement_subscriptionPage_auth";

const i18n = {
    hasNoLink: "Sorry link is broken.",
};

export function* authSaga() {
    yield delay(100);
    const [hasSessionKey, sessionData] = getSessionKey();
    const urlParams = getUrlParams();

    if (hasSessionKey && isParamsEquals(sessionData?.params, urlParams)) {
        console.log("restore token: ", sessionData.token);
    }

    if (urlParams.member) {
        yield call(loginByMemberUrl, urlParams.member);
        return;
    }
    if (urlParams.cId) {
        yield call(loadDynamicContent, Number(urlParams.cId));
    } else {
        yield call(loadDynamicContent, null);
    }
    yield put({ type: subscriptionPreferencesAT.hasntUser });

    //TODO Need to finish auth

    // if (urlParams.id && urlParams.phone) {
    //     console.log("prefill phone for customerId: ", urlParams);
    //     yield put(
    //         showErrorOnSubscriptionPreferencesAction("unsupported", true)
    //     );
    //     return;
    // }

    // yield put(showErrorOnSubscriptionPreferencesAction(i18n.hasNoLink, true));
}

function getSessionKey(): [boolean, IAuthSessionData] {
    const key = sessionStorage.getItem(authKey);
    return !key ? [false, null] : [true, JSON.stringify(key) as any];
}

const keys = ["id", "phone", "member", "cId"];

function getUrlParams(): IAuthParams {
    const params = new URLSearchParams(location.search);
    return keys.reduce(
        (s, key) => ((s[key] = params.get(key)), s),
        {} as IAuthParams
    );
}

function isParamsEquals(a: IAuthParams, b: IAuthParams) {
    if (a?.member) return a.member === b?.member;

    if (!a || !b) return false;

    return a.id && a.id === b.id && a.phone && a.phone === b.phone;
}

/*
 */
function* loginByMemberUrl(memberUrl: string) {
    const url = atob(memberUrl);

    const [isSuccess, user, response]: TApiResult = yield call(fetchSaga, url);
    if (!isSuccess) {
        yield put(
            showErrorOnSubscriptionPreferencesAction(
                "internal error: " + user.message,
                true
            )
        );
        return;
    }

    const token = response.headers.get("X-NGD-TOKEN");
    let userRecordInfo: IAuthDataSourceRecord;

    try {
        userRecordInfo = JSON.parse(response.headers.get("X-Datasource-Data"));
    } catch (e) {
        yield put(showErrorOnSubscriptionPreferencesAction(e.toString(), true));
        return;
    }

    if (!token || !userRecordInfo?.id) {
        yield put(
            showErrorOnSubscriptionPreferencesAction(
                "internal error: no auth",
                true
            )
        );
        return;
    }

    yield put(
        hasUserOnSubscriptionPreferencesAction({ token, userRecordInfo, user })
    );
}
